import { v4 as uuidv4 } from 'uuid';
import type { TNavbarDropdownElement } from './Navbar.type';

export const getNavbarUserButtonContent = () =>
  ({
    type: 'navbar_dropdown',
    attrs: {
      id: uuidv4(),
      label: 'User Options',
      style: 'card',
      padding: '24px',
    },
    content: [
      {
        type: 'navbar_dropdown_column',
        attrs: {
          id: uuidv4(),
        },
        content: [
          {
            type: 'navbar_dropdown_item',
            attrs: {
              id: uuidv4(),
              title: 'Manage Profile',
              style: 'icon',
              action: 'profile',
              showWhen: 'all_logged_in',
              icon: {
                type: 'icon',
                iconType: 'phosphor',
                iconName: 'user',
              },
            },
          },
          {
            type: 'navbar_dropdown_item',
            attrs: {
              id: uuidv4(),
              title: 'Logout',
              style: 'icon',
              action: 'logout',
              showWhen: 'all_logged_in',
              icon: {
                type: 'icon',
                iconType: 'phosphor',
                iconName: 'sign-out',
              },
            },
          },
        ],
      },
    ],
  }) as TNavbarDropdownElement;
